import React from 'react';
import { Navigate } from 'react-router-dom';
import tokenService from '../../services/tokenService';

interface RequireRoleProps {
    allow: string[];
    redirectTo: string;
    children: React.ReactNode;
}

/**
 * Route-Guard: rendert children nur, wenn der eingeloggte User eine der
 * `allow`-Rollen hat. Andernfalls Redirect zu `redirectTo`.
 *
 * Wichtig: das ist Defense-in-Depth fuer die UI. Backend-Endpunkte sind
 * unabhaengig durch ApiResource-Security gegated. Die UI-Verstecker hier
 * sorgt nur dafuer, dass z. B. ein Student gar nicht erst die
 * Kursverwaltungs-Oberflaeche sieht (Issue #153).
 */
export const RequireRole: React.FC<RequireRoleProps> = ({ allow, redirectTo, children }) => {
    const roles = tokenService.getRoles();
    const allowed = roles.some((r) => allow.includes(r));
    if (!allowed) {
        return <Navigate to={redirectTo} replace />;
    }
    return <>{children}</>;
};

export default RequireRole;
